<template>
  <VueJsModalPrimary
    v-bind="getModalAttrs"
    v-on="$listeners"
    @before-close="beforeClose"
    @before-open="beforeOpen"
  >
    <div :style="style.container">
      <div :style="style.header">
        <HeaderLargePrimary>
          Create workspace
        </HeaderLargePrimary>
        <ImagePrimary
          :src="src"
          :style="style.image"
        />
      </div>
      <BeatLoaderPrimary v-if="isRequesting" />
      <FormNewTenantPrimary
        v-else
        :form.sync="form"
      />
      <ButtonWidePrimary
        :disabled="disableButton"
        @click="createTenant"
        :style="style.button"
      >
        Continue
      </ButtonWidePrimary>
    </div>
  </VueJsModalPrimary>
</template>

<script>
  import ApiNewTenant from '@js/api/new-tenant'
  import BeatLoaderPrimary from '@modules/v2/loader/beat-loader-primary'
  import ButtonWidePrimary from '@modules/v2/button/button-wide-primary'
  import FormNewTenantPrimary from '@modules/v2/form/form-new-tenant-primary'
  import HeaderLargePrimary from '@modules/v2/header/header-large-primary'
  import ImagePrimary from '@modules/v2/image/image-primary'
  import VueJsModalPrimary from '@modules/v2/modal/vue-js-modal-primary'
  import { FormNewTenant } from '@js/forms/new-tenant'
  import { IMAGE_FILES, MODAL_WINDOW_NAMES } from '@js/constants'
  import { Layout } from '@js/styles'

  export default {
    name: 'ModalCreateTenant',
    inheritAttrs: false,
    components: {
      BeatLoaderPrimary,
      ButtonWidePrimary,
      FormNewTenantPrimary,
      HeaderLargePrimary,
      ImagePrimary,
      VueJsModalPrimary,
    },
    data: function () {
      return {
        form: new FormNewTenant(),
        isRequesting: false,
        name: MODAL_WINDOW_NAMES.CREATE_TENANT_PRIMARY,
        style: {
          button: {
            margin: `${Layout.space.xl} 0 0 0`,
          },
          container: {
            alignItems: 'center',
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            justifyContent: 'space-between',
            padding: `${Layout.space.xl} ${Layout.space.lg}`,
            width: '100%',
          },
          header: {
            alignItems: 'center',
            display: 'flex',
            flexDirection: 'column',
            textAlign: 'center',
            width: '100%',
          },
          image: {
            height: '138px',
            margin: `${Layout.space.md} 0`,
            width: '200px',
          },
        },
      };
    },
    computed: {
      disableButton: function () {
        return this.form.errors.length > 0 || this.isRequesting;
      },
      getModalAttrs: function () {
        return {
          height: 'auto',
          maxHeight: 504,
          maxWidth: 400,
          minHeight: 504,
          name: this.name,
        };
      },
      imageFile: function () {
        return IMAGE_FILES.TENANT.CREATE;
      },
      src: function () {
        return require(`@img/${this.imageFile}`);
      },
    },
    methods: {
      beforeClose: function (e) {
        this.clearState();
      },
      beforeOpen: function (e) {
        this.clearState();
      },
      clearState: function () {
        this.form = new FormNewTenant();
        this.isRequesting = false;
      },
      createTenant: async function () {
        try {
          this.isRequesting = true;
          const payload = await this.form.getPostPayload();
          const api = await new ApiNewTenant();
          const res = await api.post(payload);
          await this.$emit('created-tenant', res.data);
          await this.$modal.hide(this.name);
        } catch (error) {
          console.error(error);
          this.$store.commit('notification/setWarning', 'Failed to create tenant.');
        } finally {
          this.isRequesting = false;
        }
      },
    },
  };
</script>
